import React, { useState } from 'react';
import ProsConsExercise from './ProsConsExercise';
import './ProsConsExerciseBoard.css';

const PROS_CONS_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%)', marginRight: 20
  }}>
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="8" height="18" rx="2" />
      <rect x="13" y="3" width="8" height="18" rx="2" />
      <path d="m6.5 8 1.5 1.5 3-3" />
      <path d="m15.5 8 3 3m0-3-3 3" />
    </svg>
  </span>
);

const ProsConsExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;

  // Support both naming conventions: topic/cefr (tiptap) and title/level (older board data)
  const { pros, cons, topic, cefr, title, level } = exerciseData;
  const displayTitle = topic || title;
  const displayLevel = cefr || level;

  if (!pros || !cons || !Array.isArray(pros) || !Array.isArray(cons)) {
    return (
      <div className="pros-cons-board-error">
        <p>Error: Invalid Pros and Cons exercise data</p>
      </div>
    );
  }

  const handleExpand = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(true);
    if (onSelect) onSelect();
    if (onExpand) onExpand();
  };

  const handleClose = () => {
    if (isExpandedProp === undefined) setIsExpandedLocal(false);
    if (onClose) onClose();
  };

  return (
    <div className="pros-cons-exercise-board">
      {!isExpanded ? (
        <div
          className={`pros-cons-preview unified-exercise-preview pc-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={handleExpand}
        >
          {PROS_CONS_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{displayTitle || 'Pros and Cons Exercise'}</div>
            <div className="unified-preview-meta">
              {pros.length} pros, {cons.length} cons · Level: {displayLevel || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="pros-cons-expanded">
          <ProsConsExercise
            topic={displayTitle}
            cefr={displayLevel}
            pros={pros}
            cons={cons}
            onClose={handleClose}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default ProsConsExerciseBoard;
